export default __webpack_public_path__ + "static/media/Reader's Hood of the Burning Disc.31ced454.jpg";